import { render, staticRenderFns } from "./MainTree.vue?vue&type=template&id=246dd135&"
import script from "./MainTree.vue?vue&type=script&lang=js&"
export * from "./MainTree.vue?vue&type=script&lang=js&"
import style0 from "./MainTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports